import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Score from './Score';

const App = () => (
    <Router>
        <Routes>
            <Route path="/" element={<Score />} />
        </Routes>
    </Router>
);

export default App;